import React from 'react'

var EventFormFieldRadio = React.createClass({
  render: function() {
    const { onChange, label, name, value, response_options, required } = this.props;
    const radio_options = response_options.map( (o, i) => {

      if(value == o.name) {
        return [ <div className="row">
              <label><input type="radio" key={o.id} name={name} value={o.name} defaultChecked />&nbsp;{o.label} </label>
            </div> ];
      }
      else {
        return [ <div className="row">
              <label><input type="radio" key={o.id} name={name} value={o.name} />&nbsp;{o.label} </label>
            </div> ];
      }
      
    });


    


    return(

      <div className="form-group">
        <label className="col-lg-2 control-label">{label}{ required ? '*' : undefined }</label>
        
        <div className="col-lg-10">
          {radio_options}
        </div>

      </div>
    );
  }
});

export default EventFormFieldRadio;


// WEBPACK FOOTER //
// ./src/components/event_form_field_radio.js